module.exports = __webpack_public_path__ + "static/media/girl-16.963589e4.svg";